"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeParseAsync = exports.parseAsync = exports.safeParse = exports.parse = void 0;
const core = __importStar(require("@zod/core"));
const errors_js_1 = require("./errors.js");
exports.parse = core._parse.bind({ Error: errors_js_1.ZodError });
exports.safeParse = core._safeParse.bind({ Error: errors_js_1.ZodError });
exports.parseAsync = core._parseAsync.bind({ Error: errors_js_1.ZodError });
exports.safeParseAsync = core._safeParseAsync.bind({
    Error: errors_js_1.ZodError,
});
